var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.916,
    height: 23.213,
    viewBox: "0 0 26.916 23.213",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-warning",
    "data-name": "Icon metro-warning",
    d: "M16.029,4.031,27.307,23.418H4.75L16.029,4.031Zm0-2.1a1.959,1.959,0,0,0-1.6,1.012L2.94,22.687c-.88,1.35-.131,2.454,1.664,2.454h22.85c1.8,0,2.544-1.1,1.664-2.454h0L17.629,2.94a1.958,1.958,0,0,0-1.6-1.012Zm1.682,18.86a1.579,1.579,0,0,1-1.682,1.451,1.579,1.579,0,0,1-1.682-1.451,1.579,1.579,0,0,1,1.682-1.451A1.579,1.579,0,0,1,17.711,20.788Zm-1.682-2.9a1.579,1.579,0,0,1-1.682-1.451V12.084a1.579,1.579,0,0,1,1.682-1.451,1.579,1.579,0,0,1,1.682,1.451v4.352A1.579,1.579,0,0,1,16.029,17.887Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#ffc337"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b9d5eef5ffebfceddb7179ddfc08015a.svg";
export { ForwardRef as ReactComponent };